var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"id":"page-wrapper","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md4":"","lg3":""}},[_c('login-form')],1),_c('v-flex',{attrs:{"fill-height":"","hidden-sm-and-down":""}},[_c('login-background',{attrs:{"logo":"img/login.svg","image":"img/login-background.jpg"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }